(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-bundles"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll(".pp-rung").forEach(card => {
  const wrap = card.querySelector("[data-pp-rung-opts]");
  if (!wrap) return;
  const vid = card.querySelector(".pp-rung__vid");
  const btn = card.querySelector("button[type=submit]");
  const dataEl = wrap.querySelector(".pp-rung__data");
  let variants = [];
  if (dataEl) { try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; } }
  const selects = Array.from(wrap.querySelectorAll(".pp-rung__select"));
  if (!variants.length || !selects.length) return;

  function refresh() {
    selects.forEach((sel, i) => {
      Array.from(sel.options).forEach(opt => {
        if (!opt.dataset.label) opt.dataset.label = opt.textContent.trim();
        const ok = variants.some(v => {
          if (!v.available || v.options[i] !== opt.value) return false;
          for (let j = 0; j < i; j++) { if (v.options[j] !== selects[j].value) return false; }
          return true;
        });
        opt.disabled = !ok;
        opt.textContent = ok ? opt.dataset.label : opt.dataset.label + " (unavailable)";
      });
      const cur = sel.selectedOptions[0];
      if (cur && cur.disabled) {
        const firstOk = Array.from(sel.options).find(o => !o.disabled);
        if (firstOk) sel.value = firstOk.value;
      }
    });
    const chosen = selects.map(s => s.value);
    const v = variants.find(x => chosen.every((val, i) => x.options[i] === val));
    if (v) {
      if (vid) vid.value = v.id;
      if (btn) btn.disabled = !v.available;
    } else if (btn) {
      btn.disabled = true;
    }
  }

  selects.forEach(s => s.addEventListener("change", refresh));
  refresh();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-header"] && !Shopify.designMode) return;
  try {
    
const hdr = document.querySelector('.pp-hdr');
if (hdr) {
  const burger = hdr.querySelector('.pp-hdr__burger');
  const drawer = hdr.querySelector('.pp-hdr__drawer');
  if (burger && drawer) {
    burger.addEventListener('click', () => {
      const open = drawer.classList.toggle('open');
      burger.setAttribute('aria-expanded', String(open));
    });
    drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', () => drawer.classList.remove('open')));
  }
}

const announce = document.querySelector('[data-pp-announce]');
if (announce) {
  const items = Array.from(announce.querySelectorAll('.pp-announce__item'));
  if (items.length > 1) {
    let i = 0, hold = false;
    announce.addEventListener('mouseenter', () => { hold = true; });
    announce.addEventListener('mouseleave', () => { hold = false; });
    setInterval(() => {
      if (hold || document.hidden) return;
      items[i].classList.remove('on');
      i = (i + 1) % items.length;
      items[i].classList.add('on');
    }, 4500);
  }
}

const countEl = document.querySelector('[data-pp-cart-count]');
if (countEl) {
  const paint = n => {
    countEl.textContent = n;
    if (n > 0) { countEl.removeAttribute('hidden'); } else { countEl.setAttribute('hidden', ''); }
  };
  const refresh = () => fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(r => r.ok ? r.json() : null)
    .then(c => { if (c && typeof c.item_count === 'number') paint(c.item_count); })
    .catch(() => {});
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-inside-ring"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pp-inside]').forEach(root => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduce) {
    root.classList.add('pre');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) { root.classList.add('in'); io.disconnect(); }
        });
      }, { threshold: 0.2 });
      io.observe(root);
    } else {
      root.classList.add('in');
    }
  }

  const sensors = Array.from(root.querySelectorAll('.sensor'));
  const nodes = Array.from(root.querySelectorAll('.node'));
  const link = (i, on) => {
    const s = sensors.find(el => el.dataset.i === String(i));
    const n = nodes.find(el => el.dataset.i === String(i));
    if (s) s.classList.toggle('is-hot', on);
    if (n) n.classList.toggle('is-hot', on);
  };
  [...sensors, ...nodes].forEach(el => {
    const i = el.dataset.i;
    el.addEventListener('mouseenter', () => link(i, true));
    el.addEventListener('mouseleave', () => link(i, false));
    el.addEventListener('focusin', () => link(i, true));
    el.addEventListener('focusout', () => link(i, false));
  });

  const sweep = root.querySelector('.sweep');
  if (sweep && !reduce) {
    nodes.forEach(n => n.addEventListener('mouseenter', () => {
      const x = parseFloat(n.style.left) - 50;
      const y = parseFloat(n.style.top) - 50;
      const deg = Math.atan2(y, x) * 180 / Math.PI;
      sweep.style.transform = 'rotate(' + (deg - 16) + 'deg)';
    }));
  }
});

document.querySelectorAll('[data-pp-cutaway]').forEach(box => {
  const v = box.querySelector('video');
  if (!v) return;
  const load = () => {
    if (v.dataset.loaded) return;
    v.dataset.loaded = '1';
    v.querySelectorAll('source[data-src]').forEach(s => { s.src = s.dataset.src; });
    v.load();
    v.play().catch(() => {});
  };
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(e => { if (e[0].isIntersecting) { load(); io.disconnect(); } }, { rootMargin: '200px' });
    io.observe(box);
  } else { load(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-landing-buy"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pp-gallery').forEach(g => {
  const main = g.querySelector('.pp-gallery-main');
  g.querySelectorAll('.pp-thumbs button').forEach(b => {
    b.addEventListener('click', () => {
      g.querySelectorAll('.pp-thumbs button').forEach(x => x.classList.remove('on'));
      b.classList.add('on');
      if (main && b.dataset.full) main.src = b.dataset.full;
    });
  });
});

document.querySelectorAll('#buy').forEach(root => {
  const vid = root.querySelector('.pp-lbuy__vid');
  const finish = root.querySelector('.pp-lbuy__finish');
  const swatches = root.querySelectorAll('.pp-lbuy__swatch');
  const wrap = root.querySelector('.pp-lbuy__sizewrap');
  const sizeSel = root.querySelector('.pp-lbuy__size');
  const atc = root.querySelector('.pp-buyland__atc');
  const dataEl = root.querySelector('.pp-lbuy__variantdata');
  let variants = [];
  if (dataEl) { try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; } }
  const sizeIdx = wrap ? parseInt(wrap.dataset.sizeIndex, 10) : -1;
  const colourIdx = wrap ? parseInt(wrap.dataset.colourIndex, 10) : 0;
  const canResolve = variants.length > 0 && sizeIdx >= 0 && !!sizeSel;

  const currentColour = () => {
    const on = root.querySelector('.pp-lbuy__swatch.on');
    return on ? on.dataset.name : null;
  };

  function refreshSizes() {
    if (!canResolve) return;
    const colour = currentColour();
    Array.from(sizeSel.options).forEach(opt => {
      if (!opt.dataset.label) opt.dataset.label = opt.textContent;
      const v = variants.find(x =>
        x.options[sizeIdx] === opt.value && (colour === null || x.options[colourIdx] === colour));
      const ok = !!(v && v.available);
      opt.disabled = !ok;
      opt.textContent = ok ? opt.dataset.label : opt.dataset.label + ' (unavailable)';
    });
    const current = sizeSel.selectedOptions[0];
    if (current && current.disabled) {
      const firstOk = Array.from(sizeSel.options).find(o => !o.disabled);
      if (firstOk) sizeSel.value = firstOk.value;
    }
  }

  function resolve() {
    if (!canResolve) return;
    const colour = currentColour();
    const size = sizeSel.value;
    const v = variants.find(x =>
      x.options[sizeIdx] === size && (colour === null || x.options[colourIdx] === colour));
    if (v) {
      if (vid) vid.value = v.id;
      if (atc) { atc.disabled = !v.available; atc.dataset.soldOut = v.available ? '' : '1'; }
    } else if (atc) {
      atc.disabled = true;
      atc.dataset.soldOut = '1';
    }
  }

  const pick = (b) => {
    swatches.forEach(x => x.classList.remove('on'));
    b.classList.add('on');
    if (finish) finish.textContent = b.dataset.name || '';
    if (canResolve) { refreshSizes(); resolve(); }
    else if (vid && b.dataset.vid) vid.value = b.dataset.vid;
  };

  swatches.forEach(b => b.addEventListener('click', () => pick(b)));
  if (sizeSel) sizeSel.addEventListener('change', resolve);
  const first = root.querySelector('.pp-lbuy__swatch.on') || swatches[0];
  if (first) pick(first); else resolve();
});

document.querySelectorAll('.pp-lbuy__guide').forEach(dlg => {
  const scope = dlg.closest('section') || document;
  const open = () => {
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
  };
  const close = () => {
    if (typeof dlg.close === 'function') dlg.close();
    else dlg.removeAttribute('open');
  };
  scope.querySelectorAll('[data-pp-guide-open]').forEach(b => b.addEventListener('click', open));
  dlg.querySelectorAll('[data-pp-guide-close]').forEach(b => b.addEventListener('click', close));
  dlg.addEventListener('click', e => { if (e.target === dlg) close(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-landing-story"] && !Shopify.designMode) return;
  try {
    
const ppScenes = document.querySelectorAll('[data-pp-scene]');
if (ppScenes.length) {
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        e.target.classList.toggle('in', e.isIntersecting);
      });
    }, { threshold: 0.28 });
    ppScenes.forEach(el => io.observe(el));
  } else {
    ppScenes.forEach(el => el.classList.add('in'));
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-pdp-buy"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll(".pp-buy").forEach(root => {
  const vid = root.querySelector(".pp-buy__vid");
  const atc = root.querySelector(".pp-buy__atc");
  const opts = root.querySelector("[data-pp-opts]");
  const optNotes = Array.from(root.querySelectorAll("[data-pp-opts-note]"));
  const priceEl = root.querySelector(".pp-buy__price");
  const sizeName = opts ? (opts.dataset.sizeOption || "Size") : "Size";
  const guideLabel = (() => { const b = root.querySelector(".pp-buy__guidelink"); return b ? b.textContent : "Size guide"; })();
  const hasGuide = !!document.querySelector(".pp-buy__guide");

  const tierData = {};
  root.querySelectorAll(".pp-buy__tierdata").forEach(el => {
    try { tierData[el.dataset.tier] = JSON.parse(el.textContent); } catch (e) { }
  });

  const money = c => (c / 100).toLocaleString("en-GB", { style: "currency", currency: "GBP" });
  let current = null;

  function buildSelects(data) {
    if (!opts) return [];
    opts.querySelectorAll(".pp-buy__opt").forEach(n => n.remove());
    const names = data.names || [];
    const frag = document.createDocumentFragment();
    names.forEach((name, i) => {
      const values = [];
      data.variants.forEach(v => { const val = v.options[i]; if (val != null && values.indexOf(val) < 0) values.push(val); });
      const wrap = document.createElement("div");
      wrap.className = "pp-buy__opt";
      const head = document.createElement("span");
      head.className = "pp-buy__opthead";
      const lab = document.createElement("label");
      lab.className = "pp-buy__optlabel";
      lab.textContent = name;
      const id = "pp-buy-opt-" + (root.id || "x") + "-" + i;
      lab.htmlFor = id;
      head.appendChild(lab);
      if (name === sizeName && hasGuide) {
        const g = document.createElement("button");
        g.type = "button";
        g.className = "pp-buy__guidelink";
        g.setAttribute("data-pp-guide-open", "");
        g.setAttribute("aria-haspopup", "dialog");
        g.textContent = guideLabel;
        head.appendChild(g);
      }
      const sel = document.createElement("select");
      sel.className = "pp-buy__optselect";
      sel.id = id;
      sel.dataset.optionIndex = String(i);
      values.forEach(v => { const o = document.createElement("option"); o.value = v; o.textContent = v; sel.appendChild(o); });
      wrap.appendChild(head);
      wrap.appendChild(sel);
      frag.appendChild(wrap);
    });
    opts.insertBefore(frag, opts.firstChild);
    return Array.from(opts.querySelectorAll(".pp-buy__optselect"));
  }

  function refreshOptions(selects, variants) {
    selects.forEach((sel, i) => {
      Array.from(sel.options).forEach(opt => {
        if (!opt.dataset.label) opt.dataset.label = opt.textContent.trim();
        const ok = variants.some(v => {
          if (!v.available || v.options[i] !== opt.value) return false;
          for (let j = 0; j < i; j++) { if (v.options[j] !== selects[j].value) return false; }
          return true;
        });
        opt.disabled = !ok;
        opt.textContent = ok ? opt.dataset.label : opt.dataset.label + " (unavailable)";
      });
      const cur = sel.selectedOptions[0];
      if (cur && cur.disabled) {
        const firstOk = Array.from(sel.options).find(o => !o.disabled);
        if (firstOk) sel.value = firstOk.value;
      }
    });
  }

  function resolve() {
    if (!current) return;
    const { selects, variants } = current;
    if (!selects.length) return;
    refreshOptions(selects, variants);
    const chosen = selects.map(s => s.value);
    const v = variants.find(x => chosen.every((val, i) => x.options[i] === val));
    if (v) {
      if (vid) vid.value = v.id;
      if (priceEl && v.price != null) priceEl.textContent = money(v.price);
      atc.disabled = !v.available;
      atc.dataset.soldOut = v.available ? "" : "1";
    } else {
      atc.disabled = true;
      atc.dataset.soldOut = "1";
    }
  }

  function apply(tier) {
    const data = tierData[tier.dataset.tier];
    const multi = !!(data && data.variants && data.variants.length > 1 && (data.names || []).length);
    if (opts) opts.hidden = !multi;
    optNotes.forEach(n => { n.hidden = !multi; });
    if (multi) {
      const selects = buildSelects(data);
      selects.forEach(s => s.addEventListener("change", resolve));
      current = { selects: selects, variants: data.variants };
      resolve();
    } else {
      current = null;
      atc.disabled = false;
      atc.dataset.soldOut = "";
      if (tier.dataset.variantId && vid) vid.value = tier.dataset.variantId;
      if (priceEl && data && data.variants && data.variants[0] && data.variants[0].price != null) priceEl.textContent = money(data.variants[0].price);
    }
    if (tier.dataset.cta) atc.textContent = tier.dataset.cta;
  }

  root.querySelectorAll(".pp-tier").forEach(t => {
    t.addEventListener("click", () => {
      root.querySelectorAll(".pp-tier").forEach(x => x.classList.remove("on"));
      t.classList.add("on");
      apply(t);
    });
  });

  const on = root.querySelector(".pp-tier.on");
  if (on) apply(on);
});

document.querySelectorAll(".pp-buy__guide").forEach(dlg => {
  const scope = dlg.closest("section") || document;
  const open = () => { if (typeof dlg.showModal === "function") dlg.showModal(); else dlg.setAttribute("open", ""); };
  const close = () => { if (typeof dlg.close === "function") dlg.close(); else dlg.removeAttribute("open"); };
  scope.addEventListener("click", e => {
    const t = e.target;
    if (t && t.closest && t.closest("[data-pp-guide-open]")) open();
  });
  dlg.querySelectorAll("[data-pp-guide-close]").forEach(b => b.addEventListener("click", close));
  dlg.addEventListener("click", e => { if (e.target === dlg) close(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-pdp-gallery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pp-gal').forEach(root => {
  const chapters = [...root.querySelectorAll('.pp-ch')];
  const slides = [...root.querySelectorAll('.pp-slide')];
  const counter = root.querySelector('.pp-gal__counter');
  const countText = root.querySelector('.pp-gal__counttext');
  const btn = root.querySelector('.pp-gal__btn');
  const vars = [...root.querySelectorAll('.pp-proof__var')];
  const proofVideo = root.querySelector('.pp-proof__video');
  const capK = root.querySelector('.pp-proof__capk');
  const capT = root.querySelector('.pp-proof__capt');
  let cur = 0, paused = false, hover = false, inView = true, timer = null;
  const cmp = root.querySelector('.pp-cmp__range');
  if (cmp) cmp.addEventListener('input', () => {
    const p = cmp.value;
    root.querySelector('.pp-cmp__clip').style.width = p + '%';
    root.querySelector('.pp-cmp__over').style.width = (10000 / p).toFixed(2) + '%';
    root.querySelector('.pp-cmp__line').style.left = p + '%';
    root.querySelector('.pp-cmp__handle').style.left = p + '%';
    paused = true; sync();
  });
  function setVar(v) {
    vars.forEach(x => x.classList.remove('on'));
    v.classList.add('on');
    proofVideo.src = v.dataset.src;
    proofVideo.muted = true;
    capK.textContent = v.dataset.kicker || '';
    capT.textContent = v.dataset.caption || '';
    if (cur === 3) proofVideo.play().catch(() => {});
  }
  vars.forEach(v => v.addEventListener('click', () => { paused = true; setVar(v); sync(); }));
  if (vars.length) setVar(vars[0]);
  function sync() {
    chapters.forEach((c, i) => {
      c.classList.toggle('on', i === cur);
      c.classList.toggle('running', i === cur && !paused && !hover && inView && cur !== 1);
    });
    slides.forEach((s, i) => s.classList.toggle('on', i === cur));
    counter.classList.toggle('paused', paused || hover || cur === 1);
    countText.textContent = '0' + (cur + 1) + ' / 04 · ' + ((paused || hover || cur === 1) ? 'Paused' : 'Auto');
    if (btn && chapters[cur].dataset.cta) btn.textContent = chapters[cur].dataset.cta;
    if (cur === 3) proofVideo.play().catch(() => {}); else proofVideo.pause();
  }
  function go(i, p) { cur = i; paused = !!p; sync(); restart(); }
  chapters.forEach((c, i) => c.addEventListener('click', () => {
    if (i === cur) { paused = !paused; sync(); } else go(i, false);
  }));
  function restart() {
    clearInterval(timer);
    timer = setInterval(() => { if (!paused && !hover && inView && cur !== 1) { cur = (cur + 1) % slides.length; sync(); } }, 6000);
  }
  const stage = root.querySelector('.pp-gal__stage');
  stage.addEventListener('mouseenter', () => { hover = true; sync(); });
  stage.addEventListener('mouseleave', () => { hover = false; sync(); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => { inView = e.isIntersecting; }, { threshold: 0.35 }).observe(stage);
  }
  sync(); restart();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-sticky-atc"] && !Shopify.designMode) return;
  try {
    
const bar = document.querySelector('.pp-stickybar');
if (bar) {
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      const vh = window.innerHeight;
      const inView = (el) => { if (!el) return false; const r = el.getBoundingClientRect(); return r.top < vh && r.bottom > 0; };
      const buy = document.getElementById('buy') || document.getElementById('pp-buy');
      const foot = document.querySelector('.pp-foot, .pp-footer');
      const show = window.scrollY > vh && !inView(buy) && !inView(foot);
      bar.classList.toggle('show', show);
      bar.setAttribute('aria-hidden', String(!show));
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-ugc-video"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pp-ugc').forEach(root => {
  const btn = root.querySelector('.pp-ugc__play');
  const vid = root.querySelector('.pp-ugc__video');
  if (!btn || !vid) return;
  btn.addEventListener('click', () => {
    btn.hidden = true;
    vid.hidden = false;
    vid.muted = false;
    vid.controls = true;
    vid.loop = false;
    vid.play().catch(() => { vid.muted = true; vid.play().catch(() => {}); });
  });
});

  } catch(e) { console.error(e); }
})();
})();
